import { Box } from '@nimbus-ds/components';
import { PlusCircleIcon } from '@nimbus-ds/icons';
import { CalloutCard } from '@nimbus-ds/patterns';
import { useNavegate } from 'App/hooks';
import ModalButtons from 'domains/Customers/Customers/pages/CustomerListPage/components/FilterModal/components/ModalButtons';
import { useTranslationCustomers } from 'domains/Customers/hooks';

export default function ModalFooter({ handleReset, handleApply }) {
  const t = useTranslationCustomers();
  const { goTo } = useNavegate();

  return (
    <Box display="flex" flexDirection="column" width="100%" gap="2">
      <CalloutCard
        title={t('customerListPage.filterModal.calloutEmptyState.title')}
        appearance="primary"
        subtitle={t(
          'customerListPage.filterModal.calloutEmptyState.description',
        )}
        icon={PlusCircleIcon}
        onClick={() => goTo('/settings/metafields')}
      />
      <ModalButtons handleReset={handleReset} handleApply={handleApply} />
    </Box>
  );
}
